import { render } from "./NewBookDialog.vue?vue&type=template&id=56116b83&scoped=true"
import script from "./NewBookDialog.vue?vue&type=script&lang=js"
export * from "./NewBookDialog.vue?vue&type=script&lang=js"

import "./NewBookDialog.vue?vue&type=style&index=0&id=56116b83&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56116b83"]])

export default __exports__